import { makeAPIRequest } from "./makeRequest";

export const postEnableUsers = (data: any) => {
    let config = {
        method: 'GET',
        url: process.env.REACT_APP_SERVER_URL + 'User/Enable?userData=' + data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Type': 'text'
        }
    }

    let res = makeAPIRequest(config);
    return res
}

export const postEnableUsersScanMenu = (data: any) => {
    let config = {
        method: 'GET',
        url: process.env.REACT_APP_SERVER_URL + 'User/EnableScanMenuConfig?userData=' + data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Type': 'text'
        }
    }

    let res = makeAPIRequest(config);
    return res
}